var map = {
	"./header-video-desktop.mp4": "ec28",
	"./header-video.mp4": "2829",
	"./video-banner-desktop.mp4": "6614",
	"./video-banner-poster-desktop.jpg": "7127",
	"./video-banner-poster.jpg": "a54c",
	"./video-banner.mp4": "70ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a938";